import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { usePersonalCollectionItem, type PersonalCollectionKind } from "@/hooks/useCollections";
import type { CollectionItemType } from "@/types/collections";
import type { LeafActionSet } from "@/components/layout/LeafActions";

/** Shared account actions for stash headers and Stuff headers/rows. */
export function usePersonalItemActions(type: CollectionItemType, id: string, menuOpen: boolean): LeafActionSet {
  const { isAuthenticated } = useAuth();
  const membership = usePersonalCollectionItem({ type, id }, isAuthenticated && menuOpen);
  const change = async (kind: PersonalCollectionKind, selected: boolean) => {
    try {
      await membership.set({ kind, selected });
      toast.success(kind === "done"
        ? selected ? "Marked as done" : "Marked as not done"
        : selected ? "Added to favorites" : "Removed from favorites");
    } catch {
      toast.error("Couldn't save your change. Please try again.");
    }
  };
  if (!isAuthenticated) return {};
  const disabled = !membership.ready || membership.writing;
  return {
    favorite: {
      label: membership.favourite ? "Remove from favorites" : "Add to favorites",
      disabled,
      onSelect: () => { void change("favourites", !membership.favourite); },
    },
    done: {
      label: membership.done ? "Mark as not done" : "Mark as done",
      disabled,
      onSelect: () => { void change("done", !membership.done); },
    },
  };
}
